import { render } from "./UserGroup.vue?vue&type=template&id=024cd154&scoped=true"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"

import "./UserGroup.vue?vue&type=style&index=0&id=024cd154&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024cd154"]])

export default __exports__